export const errors = {
  required: 'Este campo es obligatorio',
  email: 'Por favor, ingresa una dirección de correo electrónico válida',
  dateOfBirth: 'Por favor, ingresa una fecha de nacimiento válida',
  atLeastOne: 'Debe proporcionarse al menos un campo',
  invalidEmailOrPhone: 'El campo debe ser un correo electrónico o número de teléfono válido',
  minlength: 'El número de caracteres no debe ser menor que {{requiredLength}}',
  maxlength: 'El número de caracteres no debe ser mayor que {{requiredLength}}',
  notValid: 'El campo no es válido',
  somethingWentWrong: 'Ups, algo salió mal.',
  scheduleOutsideWorkingHours:
    'Unirse a la fila no está disponible actualmente porque el hospital está cerrado. Por favor, utiliza la opción ’Programar para más tarde’.',
  contactInUse: '{{ contact }} ya está en uso. Por favor, intenta con otro.',
  invalidPhone: 'Número de teléfono no válido',
  poBox: 'No enviamos a apartados postales. Por favor, ingrese una dirección residencial o comercial.',
  unknownAddress: 'Dirección desconocida',
  validateAddress: 'Error al validar el domicilio',
  paymentFailed: 'No pudimos procesar tu pago. Por favor, intenta actualizar tu método de pago.',
  updatePaymentError: 'No se pudo actualizar el método de pago.',
};
